<template>
  <div class="print-pay-fee-container">
    <div class="text-center">
      <div style="color:#000;font-size:26px">{{printPayFeeInfo.communityName}}
        <span v-if="printPayFeeInfo.apply === 'Y'">{{ $t('printPayFee.apply') }}</span>
        <span v-if="printPayFeeInfo.apply === 'N'">{{ $t('printPayFee.receipt') }}</span>
        <span v-if="printPayFeeInfo.apply === 'R'">{{ $t('printPayFee.refund') }}</span>
      </div>
    </div>
    <div style="color:#000;font-size:18px;">     <!-- 去掉margin-left:20px,让业主放在最左  update by cht at 2026/6/18 11:50 -->
      <div class="float-left">
        <span></span>
        <br />
        {{ $t('printPayFee.owner') }}：{{printPayFeeInfo.payObjName}}
      </div>
      <div class="float-right text-right">
        <span>{{ $t('printPayFee.receiptNum') }}{{printPayFeeInfo.receiptNum}}</span>
        <br />
        <span>{{ $t('printPayFee.payTime') }}：{{printPayFeeInfo.feeTime}}</span>
      </div>
    </div>

    <table class="table vc-table-border" style="color:#000;font-size:18px;width:100%;border-collapse:collapse;">
      <thead>
        <tr>
          <th class="text-center" width="80px">{{ $t('printPayFee.serialNumber') }}</th>
          <th class="text-center">{{ $t('printPayFee.feeItem') }}</th>
          <th class="text-center">{{ $t('printPayFee.houseCar') }}</th>
          <th class="text-center">{{ $t('printPayFee.feeRange') }}</th>
          <th class="text-center">{{ $t('printPayFee.unitPrice') }}</th>
          <th class="text-center">{{ $t('printPayFee.areaUsage') }}</th>
<!--          <th class="text-center">{{ $t('printPayFee.feeCoefficient') }}</th>   &lt;!&ndash; create by cht at 2026/7/9 11:25 &ndash;&gt;-->
          <th class="text-center">{{ $t('printPayFee.paymentMethod') }}</th>
          <th class="text-center">{{ $t('printPayFee.receivableActual') }}</th>
          <th class="text-center">{{ $t('printPayFee.discountAmount') }}</th>
          <th class="text-center">{{ $t('printPayFee.remark') }}</th>
        </tr>
      </thead>
      <tbody style="color:#000;font-size:20px">
        <tr v-for="(item,index) in printPayFeeInfo.fees" :key="index" class="vc-table-border">
          <th scope="row" class="text-center">{{index +1}}</th>
          <td class="text-center">{{item.feeName}}</td>
          <td class="text-center">{{item.objName}}</td>
          <td class="text-center">
            <div v-if="item.preDegrees">
              {{dateFormat(item.startTime)}}
              <span>{{ $t('printPayFee.to') }}</span>
              {{dateFormat(item.endTime)}}<br />
              {{item.preDegrees}} {{ $t('printPayFee.to') }} {{item.curDegrees}}
            </div>
            <div v-else-if="item.feeTypeCd === '888800010006'">
              {{ $t('printPayFee.none') }}
            </div>
            <div v-else>
              {{dateFormat(item.startTime)}}{{$t('printPayFee.to')}}{{dateFormat(item.endTime)}}
            </div>
          </td>
<!--          <td class="text-center">{{item.squarePrice}}<br />{{item.units}}</td>-->
<!--          <td class="text-center">{{item.area}}</td>-->
          <!-- create by cht at 2026/7/13 16:30 -->
          <td class="text-center">
            <span v-if="item.squarePrice">{{item.squarePrice}}<br />{{item.units}}</span>
            <span v-else>-</span>
          </td>
          <td class="text-center">
            <span v-if="item.area">{{item.area}}</span>
            <span v-else>-</span>
          </td>
          <!-- create by cht at 2026/7/9 17:15 -->
<!--          <td class="text-center">-->
<!--            <span v-if="item.feeTypeCd === '888800010016' && (item.computingFormula === '5005' || item.computingFormula === '9009')">-->
<!--              {{item.feeCoefficient}}-->
<!--            </span>-->
<!--            <span v-else>-</span>-->
<!--          </td>-->
          <td class="text-center">{{item.primeRate}}</td>
          <td class="text-center">
            {{item.receivableAmount}}/{{item.amount}}{{$t('printPayFee.yuan')}}
            <span v-if="item.amount < 0">({{ $t('printPayFee.refund') }})</span>
          </td>
          <td class="text-center">{{item.discountPrice || 0}}</td>
          <td class="text-center" width="200px">{{item.remark}}</td>
        </tr>
        <tr>
          <td colspan="3" class="text-center">{{ $t('printPayFee.capitalRMB') }}</td>
          <td colspan="2" class="text-center">{{changeNumMoneyToChinese(printPayFeeInfo.amount)}}</td>
          <td colspan="1" class="text-center">{{printPayFeeInfo.amount}}</td>
          <td colspan="2" class="text-center">{{ $t('printPayFee.accountDeduction') }}</td>
          <td colspan="2" class="text-center">{{printPayFeeInfo.acctAmount}}</td>
        </tr>
        <tr v-if="printPayFeeInfo.content || printPayFeeInfo.qrImg">
          <td colspan="6">
            <div style="max-width: 600px;" v-html="printPayFeeInfo.content"></div>
          </td>
          <td colspan="4">
            <img v-if="printPayFeeInfo.qrImg" :src="printPayFeeInfo.qrImg" width="100px" height="100px">
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 增加(position: relative;)相对定位、去掉(class="flex justify-between"),替换为(display: flex; justify-content: space-between;)     create by cht at 2026/6/18 11:10 -->
    <el-row style="color:#000;font-size:18px;text-align: left;  position: relative; display: flex; justify-content: space-between;">
      <!-- 公章：放在签字栏内，但向上偏移覆盖到表格区域 -->
      <div class="seal-wrapper">
        <img
            v-if="printPayFeeInfo.officialSealUrl"
            :src="printPayFeeInfo.officialSealUrl"
            class="official-seal"
        />
      </div>

      <!--  :span="6"改为  style="flex: 1;"  update by cht at 2026/6/18 11:30 -->
      <el-col style="flex: 1;">{{ $t('printPayFee.departmentHead') }}</el-col>
      <el-col style="flex: 1;">{{ $t('printPayFee.financeReceipt') }}</el-col>
      <el-col style="flex: 1;">{{ $t('printPayFee.customerConfirm') }}</el-col>
      <el-col style="flex: 2; text-align: right">{{ $t('printPayFee.operator') }}{{userInfo.name}}</el-col>
    </el-row>

    <!-- 把打印按钮放到单独的容器里  create by cht at 2026/6/12 10:45 -->
    <div id="print-btn-area">
      <el-col :span="24">
        <el-button type="primary" class="float-right" @click="handlePrint">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
        </el-button>
        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">
          {{ $t('common.cancel') }}
        </el-button>
      </el-col>
    </div>

<!--    <el-row id="print-btn">-->
<!--      <el-col :span="24">-->
<!--        <el-button type="primary" class="float-right" @click="handlePrint">-->
<!--          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}-->
<!--        </el-button>-->
<!--        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">-->
<!--          {{ $t('common.cancel') }}-->
<!--        </el-button>-->
<!--      </el-col>-->
<!--    </el-row>-->
  </div>
</template>

<script>
// 新增:引入 listMyCommunity 接口 create by cht at 2026/6/22 9:50
import { listMyCommunity } from '@/api/community/enterCommunityApi'
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintPayFeeList',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        roomName: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        feeReceipt: [],
        apply: 'N',
        receiptNum: '',
        officialSealUrl: '', // 写一个公开的公章图片地址https://app.gzlmzj.com/storage/uploads/images/Mywuyexiaoqu/20260107/2ca2f1f770dad8dd4db3ab1575c06bc4.png
        acctAmount: 0
      },
      userInfo: {},
      printFlag: '0',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      if(this.$route.query.apply){
        this.printPayFeeInfo.apply = this.$route.query.apply
      }
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName =  getCommunityName()

      this.loadReceipt()
      this.loadPrintSpec()
      this.loadOfficialSeal()  // 新增:查询公章 create by cht at 2026/6/22 9:50
    },
    /*===================公章查询方法 create by cht at 2026/6/22 9:50====================*/
    loadOfficialSeal() {
      console.log('loadOfficialSeal called, communityId:', this.communityId)
      const params = {
        page: 1,
        row: 10,
        communityId: this.getCommunityId()
      }
      listMyCommunity(params).then(response => {
        const data = response
        console.log('data是:', data)
        if (data && data.length > 0) {
          const community = data[0]
          if (community.communityAttrDtos && Array.isArray(community.communityAttrDtos)) {
            const sealAttr = community.communityAttrDtos.find(attr => attr.specCd === '1005320999')
            if (sealAttr && sealAttr.value) {
              this.printPayFeeInfo.officialSealUrl = sealAttr.value
            }
          }
        }
      })
    },
    /*===================by cht====================*/
    loadReceipt() {
      const params = {
        page: 1,
        row: 30,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        this.printPayFeeInfo.roomName = feeReceipt[0].objName
        this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
        this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode

        this.loadReceiptDetail()
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        console.log("feeReceiptDetails是",feeReceiptDetails)
        this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + "(" + feeReceiptDetails[0].payOrderId + ")"
        if (feeReceiptDetails[0].amount < 0) {
          this.printPayFeeInfo.apply = 'R'
        }
        let acctAmount = 0.0
        feeReceiptDetails.forEach(item => {
          acctAmount = acctAmount + parseFloat(item.acctAmount)
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        this.printPayFeeInfo.acctAmount = acctAmount.toFixed(2)
      })
    },
    loadPrintSpec() {
      const params = {
        page: 1,
        row: 1,
        specCd: 2020,
        communityId: this.communityId
      }

      queryFeePrintSpec(params).then(response => {
        const data = response.data
        if (data.length > 0) {
          this.printPayFeeInfo.content = data[0].content
          this.printPayFeeInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printPayFeeInfo.communityName = data[0].printName
          }
        }
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      // document.getElementById("print-btn").style.display = "none"  //delete by cht  at 2026/6/12 10:50
      document.getElementById("print-btn-area").style.display = "none"  //create by cht at 2026/6/12 14:30
      window.print()
      window.close()
    },
    handleClose() {
      window.close()
    }
  }
}
</script>

<style scoped>
.print-pay-fee-container {
  padding: 20px;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.el-row {
  width: 100%;
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}

/*=======================by cht============================*/
.seal-wrapper {
  position: absolute;
  right: 10px;        /* 靠右 */
  top: -40px;         /* 关键：向上偏移，负值表示超出签字栏顶部，覆盖到表格最后一行 */
  pointer-events: none;
  z-index: 10;
}

.official-seal {
  width: 190px;       /* 公章稍大一点，更像真实盖章 */
  height: 120px;
  /*opacity: 0.8;      !* 透明度，更像真实盖章 *!*/
}

#print-btn-area {
  position: relative;
  z-index: 20;        /* 确保打印按钮在最上层，不被公章遮挡 */
  margin-top: 60px;   /* 与上面的内容保持距离 */
}
/*=====================by cht==========================*/
</style>
